module.exports = __webpack_public_path__ + "app-static/img/07.20fd709a.jpg";